import styled from '@benzinga/themetron';
import SectionRating from './SectionRating';
import { RatingsProps } from '../TechnicalsFinancialsAnalysis';

export const OverviewRating: React.FC<{ ratings: RatingsProps }> = ({ ratings }) => {
  const { color, text } = getRatingTextAndColor(ratings.down, ratings.up);
  return (
    <Container className="flex gap-2 justify-between overview-section">
      <div className="flex items-center justify-between w-full">
        <div className="flex flex-col justify-center">
          <div className="overview-rating-title font-bold text-gray-600">Overview Rating:</div>
          <div className={`overview-rating-value font-semibold text-2xl ${color}`}>{text}</div>
        </div>
        <SectionRating className="ratings-circle w-[80px] h-[80px]" down={ratings.down} up={ratings.up} />
      </div>
    </Container>
    // <Container className="flex gap-2 justify-between overview-section">
    //   <div className="flex flex-row md:justify-normal w-full">
    //     <SectionRating className="ratings-circle w-[80px] h-[80px]" down={ratings.down} up={ratings.up} />
    //     <div className="flex flex-col gap-0 md:ml-12 justify-center">
    //       <div className="font-bold text-gray-600 overview-title">Overview Rating</div>
    //       <div className={`${color} font-semibold text-2xl`}>{text}</div>
    //     </div>
    //   </div>
    // </Container>
  );
};

const getRatingTextAndColor = (down: number, up: number) => {
  // If up > 90% - Very promising asset
  // If up > 75% - Promising asset
  // If up > 50% - Good asset
  // If up > 25% - Neutral asset
  // If up > 0% - Unpromising asset
  const total = down + up;
  const rating = up / total;
  if (rating > 0.9) {
    return { color: 'text-green-500', text: 'Very Promising' };
  }
  if (rating > 0.75) {
    return { color: 'text-green-500', text: 'Promising' };
  }
  if (rating > 0.5) {
    return { color: 'text-green-500', text: 'Good' };
  }
  if (rating > 0.25) {
    return { color: 'text-red-500', text: 'Speculative' };
  }
  return { color: 'text-red-500', text: 'Speculative' };
};

const Container = styled.div`
  height: 50px;

  .overview-title {
    color: #5b7292;
    text-transform: uppercase;
    font-size: 12px;
    font-weight: 700;
    white-space: nowrap;
  }

  .ratings-circle {
    height: 50px;
    width: 50px;
    //padding: 4px;
    //background: #f2f8ff;
    //margin-right: 1rem;
    /* @media (min-width: 769px) {
      border: 1px solid #ceddf2;
      border-right: none;
      border-top-left-radius: 50%;
      border-bottom-left-radius: 50%;
      position: absolute;
      left: -32px;
      top: 50%;
      transform: translateY(-50%);
    } */
  }

  .ratings-section {
    display: flex;

    @media (max-width: 768px) {
      flex-direction: column;
      gap: 4px;
    }
  }
`;
